import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { toast } from 'react-hot-toast'
import fitdocApi from "src/lib/axios";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function getFitdocTokenByRole (role_ids:number | string) {
    const role = role_ids?.toString()?.split(';')[0] || ''
    let token:string | undefined = undefined;

    switch (role.toString()) {
        case '1':
            token = process.env.REACT_APP_FITDOC_ADMTOK;
            break;
        case '2':
            token = process.env.REACT_APP_FITDOC_EMTOK;
            break;
        case '3':
            token = process.env.REACT_APP_FITDOC_AFTOK;
            break;
        case '4':
            token = process.env.REACT_APP_FITDOC_ABTOK;
            break;
        default:
            break;
    }

    return token;
}

export async function handleDownloadDocument (docid?:string | number) {
    try {
        if(!docid) throw new Error('No document ID provided');

        toast.loading('Downloading document...', { id:'download-document' })

        const { data } = await fitdocApi.get('documents/get', {
            params: {
                docid: docid
            }
        })
        if(data.errorcode!==0)  throw new Error('Error downloading document');
        if(!data.object) throw new Error('Error downloading document');

        const linkSource = `data:application/pdf;base64,${data.object.file}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = data?.object?.filename;
        downloadLink.click();

        toast.success('Document downloaded', { id:'download-document' })
    } catch (err) {
        toast.error('Error downloading document', { id:'download-document' })
    }
}